(function() {
    'use strict';

    angular.module('mychart').controller('PatientDocumentsCtrl', [
        PatientDocumentsCtrl
    ]);

    function PatientDocumentsCtrl(
    ) {
        console.log('WORKING');

        var vm = this;

        vm.loading = false;
        vm.context = null;
    }

})();